





























































import Component from 'vue-class-component';
import Vue from 'vue';
import {Styles} from "../store";

@Component
export default class Toolbar extends Vue {
  styles: Styles | any = {};

  created(): void {
    this.styles = this.$store.state.remote_data.styles;
  }
}
